/*
 *  @providesModule FriendsNewBannerStyles
 */

import SkillzStyle from "SkillzStyle";
import Sizes from "Sizes";

import {
  StyleSheet,
} from 'react-native';

const {
  btnTextColorOne,
  fontSizeH5,
  fontSizeH6,
  fontSecondary,
  tabHighlightColor,
  textShadowTwo
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  container: {
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    position: 'absolute',
    width: Sizes.dynamic({
      sm: 27,
      xxlg: 39,
    }),
    height: Sizes.dynamic({
      sm: 27,
      xxlg: 39,
    }),
  },

  triangleCorner: {
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    position: 'absolute',
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderRightWidth: Sizes.dynamic({
      sm: 27,
      xxlg: 39,
    }),
    borderTopWidth: Sizes.dynamic({
      sm: 27,
      xxlg: 39,
    }),
    borderRightColor: 'transparent',
    borderTopColor: tabHighlightColor.color,
    ...textShadowTwo
  },

  text: {
    alignSelf: 'flex-start',
    justifyContent: 'center',
    textAlign: 'center',
    textAlignVertical: 'center',
    backgroundColor: 'transparent',
    transform: [{rotate: '-44deg'}],
    paddingVertical: 6,
    paddingLeft: 3,
    ...fontSecondary,
    ...btnTextColorOne,
    ...Sizes.dynamic({
      sm: {
        ...fontSizeH6
      },
      xxlg: {
        ...fontSizeH5
      },
    })
  }
});
